const content: { [key: string]: string } = {
  breadcrumbsAriaLabel: "Breadcrumb",
};

export default content;
